<template>
    <div >
        <div >
            <div >
                <section class="item-types">
                    <h2 class="titlePage_subtitle titlePage">WHEELS</h2>
                    <div class="row">

                        <div class="col-sm-6 col-md-4 col-12"
                             v-for="item in selection"
                             :key="item.id"
                             >
                            <label class="form__label form__label_row">
                                <input type="radio" hidden="hidden"
                                       class="form__radio"
                                       name="mesh"
                                       @change="selectOption(item)"
                                       v-bind:checked="item.selected"
                                >
                                <span class="form__radio_icon"></span>
                                <span class="form__labelTitle">{{item.name}}</span>
                            </label>
                        </div>
                    </div>
                    <button type="button" class="btn btn_default" @click.prevent="next">next</button>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';

    export default {
        name: "Wheel",
        data() {
            return {
                checked: '',
                selection: [],
            }
        },
        components: {},
        methods: {

            ...mapMutations('bulkEditor', ['setOption']),
            ...mapActions('bulkEditor', ['update']),

            selectOption(item) {

                _.forEach(this.selection, (i, k) => {
                    i.selected = item.name === i.name;
                });
            },

            next() {
                this.setOption({
                    o: 'WHL',
                    d: this.selection
                })
                this.update({
                    type: 'option'
                })
            },

            checkDefault() {
                let result;
                // _.find(this.selection.groups.default.choices, (option) => {
                //     if (option.default) {
                //         this.selectOption(option);
                //     }
                // });
            },

            closePopup() {
                this.$store.commit('options/closeAvailable');
            },
        },

        computed: {
            ...mapState('bulkEditor', ['selections']),
        },

        created() {
            this.selection = this.selections.options.WHL.items.groups.default.choices;
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../../assets/scss/utils/vars";

    .form {
        &__label {
            margin-top: 0;
            margin-bottom: 20px;
        }

        &__input {
            border: none;
            border-bottom: 2px solid $navy;
        }

        &__labelTitle {
            color: $navy;
        }
    }

    .text_white {
        position: absolute;
        bottom: 3rem;
        left: auto;
        right: 2rem;
        display: inline-block;
        width: auto;
    }

    .modal__close {
        color: $green;
    }
</style>
